import TextSearch from './TextSearch';

export default TextSearch;
